const initialState = {}

export default function integrationsReducer(state = initialState) {
  return state
}
